import { useLazyQuery } from "@apollo/client/react";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useMemo, useState } from "react";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";

import { adaptDocumentoById, GET_ARCHIVO_DOCUMENTO_ASISTENCIAL } from '../../../../../data/graphQL/queries/GestionAsistencial/getDocumentoById';

// Config pura, fuera del hook: columnas propias de cada variante (sin la columna "action",
// que depende de handleClickView y por eso se arma dentro del hook).
const COLUMN_DEFINITIONS = {
    visitas: [
        { width: 0.1, field: "Hidden", headerName: "", hide: true },
        { flex: 4, field: "tipoProfesional", headerName: "Tipo profesional" },
        { flex: 4, field: "profesional", headerName: "Profesional" },
        { flex: 2, field: "referencia", headerName: "Referencia" },
        { flex: 2, field: "nroTalonario", headerName: "Nro. Talonario" }],

    archivosCargados: [
        { width: 0.1, field: "Hidden", headerName: "", hide: true },
        { flex: 2, field: "idArchivo", headerName: "Id Archivo" },
        { flex: 3, field: "tipoArchivo", headerName: "Tipo Archivo" },
        { flex: 4, field: "titulo", headerName: "Archivo" },
        { flex: 5, field: "datos", headerName: "Datos" },
        { flex: 2, field: "fechaAlta", headerName: "Fecha alta" }]

};

export function useTabDocumentacion(variant, data) {

    const [fileToView, setFileToView] = useState();

    const [getDocumentoById] = useLazyQuery(GET_ARCHIVO_DOCUMENTO_ASISTENCIAL, {
        fetchPolicy: 'no-cache'
    });

    const handleClickView = async (row) => {
        const response = await getDocumentoById({
            variables: {
                idArchivo: row?.idArchivo,
                idTipoArchivoDocumento: row?.idTipoArchivoDocumento
            }
        });

        setFileToView(adaptDocumentoById(response?.data));
    };

    const resetFileToView = () => setFileToView();

    const initialColumns = [
        ...COLUMN_DEFINITIONS[variant],
        {
            headerName: "",
            field: "action",
            align: "center",
            flex: 1,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <div
                        aria-hidden='true'
                        onClick={() => handleClickView(row)}
                        className="clickable-option">

                        <AttachFileIcon className="edit-icon" sx={{ paddingTop: '5px' }} />
                    </div>);

            }
        }];

    const columns = useMemo(
        () => generateColumnsDefaultConfiguration(initialColumns),
        [data]
    );

    return { columns, fileToView, resetFileToView };
}